import React from 'react';

import { ContactEntity } from '~/components/Contact';
import LEGACY_ORG_FEATURES from '~/server_shared/generated-types/LEGACY_ORG_FEATURES';
import { isLegacyOrgFeatureEnabled, stringCmp } from '~/Utils';

function adjustColumnForMgm(columnData) {
  let mgmColumnData = columnData.filter((column) => column.id !== 'label_text');
  mgmColumnData = mgmColumnData.map((column) => {
    switch (column.id) {
      case 'insured_contact_full_name':
        return {
          id: 'claimant_contact_full_name',
          numeric: false,
          disablePadding: false,
          label: 'Claimant',
          disableSort: true,
          specialCell: (claimNotification) =>
            claimNotification.claimant_contact_id ? (
              <ContactEntity
                inline
                contactId={claimNotification.claimant_contact_id}
                contactDisplayName={claimNotification.claimant_contact_full_name}
              />
            ) : null,
          specialCmpFunc: (claimNotification1, claimNotification2) =>
            stringCmp(
              claimNotification1.claimant_contact_full_name || '',
              claimNotification2.claimant_contact_full_name || ''
            ),
        };
      default:
        return column;
    }
  });

  return mgmColumnData;
}

export function adjustNotificationColumnsByUserOrg(organization, columnData) {
  let newColumnData = columnData;
  if (isLegacyOrgFeatureEnabled(organization, LEGACY_ORG_FEATURES.HOSPITALITY_TABLE_LAYOUT)) {
    newColumnData = adjustColumnForMgm(columnData);
  }
  return newColumnData;
}
